module.exports = __webpack_public_path__ + "img/icon-1.3375418.png";